import styled from "styled-components";

export const ButtonWith = styled.div`
    width: 100%;
`;
